import { useOutletContext } from "react-router-dom";
import { isEmpty } from "lodash";
// components
import ContentMetricsString from "@/components/ContentMetrics/ContentMetricsString";
// type
import { TMainPageLayoutV3 } from "../type";
import TOutletContext from "@/cms/types/TOutletContext";
import TClientTagList from "@/cms/types/TClientTagList";
// utilities
import { dateTimeToHumanReadable } from "@/utilities/DateTimeHelper";


type TRender = {
    creationDateTime:string;
    webApplicationLanguageCode:string;
    tags?:TClientTagList[];
    contentId:string;
}

const Render = ( props:TRender ) => {

    const dateTimeHR = dateTimeToHumanReadable(props.creationDateTime, props.webApplicationLanguageCode);

    return (
        <ul className="post-list d-flex align-items-center">
            {
                dateTimeHR && (
                    <li>
                        <i className="fa-solid fa-calendar-days" />
                        <time dateTime={props.creationDateTime}>
                            {dateTimeHR}
                        </time>
                    </li>
                )
            }
            {
                props.tags && !isEmpty(props.tags) && (
                    <li>
                        <i className="fa-solid fa-tag" />
                        {props.tags[0].name}
                    </li>
                )
            }
            <li>
                <ContentMetricsString
                    contentId={props.contentId}
                    className="d-inline-flex gap-2 flex-grow-1 justify-content-end"
                />
            </li>
        </ul>
    )
}

const MNPG037 = ( props: TMainPageLayoutV3 ) => {
    console.log("MNPG037.rendered: ", props);

    const { webApplicationLanguageCode } = useOutletContext<TOutletContext>();

    if ( !props.params?.["contentDetails"] || isEmpty(props.params?.["contentDetails"]) ) return null;

    return <Render 
        creationDateTime={props.params["contentDetails"].creationDateTime} 
        tags={props.params["contentDetails"].tags} 
        webApplicationLanguageCode={webApplicationLanguageCode} 
        contentId={props.params?.["contentDetails"].id}
    />

}

export default MNPG037;
